module.exports = __webpack_public_path__ + "static/media/banner_news_autenticar_documentos.a698f2a3.png";